<ng-container *ngIf="breadcrumbItems$ | async as breadcrumbItems; else staticBreadcrumbs">
  <div class="breadcrumb" *ngIf="breadcrumbItems?.length">
    <div class="breadcrumb__item" *ngFor="let breadcrumbItem of breadcrumbItems; let last = last">
      <div class="breadcrumb__item-label" (click)="navigateTo(breadcrumbItem.link)">
        {{ breadcrumbItem.text }}
      </div>

      <tp-icon
        *ngIf="!last"
        class="breadcrumb__arrow"
        name="icons/breadcrumb-right-arrow"
      ></tp-icon>
    </div>
  </div>
</ng-container>

<!--  TODO - static will go away -->
<ng-template #staticBreadcrumbs>
  <div class="breadcrumb" *ngIf="items?.length">
    <div class="breadcrumb__item" *ngFor="let item of items; let last = last">
      <div class="breadcrumb__item-label text-truncate" (click)="navigateTo(item.link)">
        {{ item.text }}
      </div>

      <tp-icon
        *ngIf="!last"
        class="breadcrumb__arrow"
        name="icons/breadcrumb-right-arrow"
      ></tp-icon>
    </div>
  </div>
</ng-template>
